import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-asesoria-gerente-servicios',
  templateUrl: './asesoria-gerente-servicios.component.html',
  styleUrls: ['./asesoria-gerente-servicios.component.scss'],
})
export class AsesoriaGerenteServiciosComponent implements OnInit {
  form: FormGroup;

  @Input() data: { task: any };

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    const { task } = this.data;
    const values = task.data ? task.data : null;
    this.form = this.fb.group({
      descripcion: [values ? values.descripcion : '', [Validators.required]],
      nombre: [values ? values.nombre : '', [Validators.required]],
      cargo: [values ? values.cargo : '', [Validators.required]],
      NM: [values ? values.NM : '', [Validators.required]],
    });
  }
  verificateInput(value: string) {
    return (
      this.form.get(value)?.invalid &&
      (this.form.get(value)?.dirty || this.form.get(value)?.touched)
    );
  }
}
